// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"626f2308","62":"27e5278a","86":"04c6f469","184":"a3ac9d7a","219":"e00989a9","639":"90b7a486","644":"37672a04","955":"c620715d"}[chunkId] + ".chunk.js";
};